import { Component, OnInit, Input, Output, EventEmitter, Renderer2, ElementRef, ViewChild, AfterContentInit, DoCheck } from '@angular/core';
import { RowResult } from '../models/row-result.model';
import { RowDetail } from '../models/row-detail.model';
import { ReportSettings } from '../../report-settings/models/reportsettings.model';
import { trigger, state, style, animate, transition } from '@angular/animations';
import { getMaxLength } from '../functions/dynamic-rows';

@Component({
  animations: [
    trigger('rotation', [
      state('default', style({
        'transform': 'rotate(0deg)'
      })),
      state('rotate', style({
        'transform': 'rotate(180deg)'
      })),
      transition('* <=> *',  animate('200ms 0s ease-in-out'))
    ]),
  ],
  selector: 'app-report-row',
  templateUrl: './report-row.component.html',
  styleUrls: ['./report-row.component.scss']
})
export class ReportRowComponent implements OnInit, DoCheck {

  //#region Inputs

  @Input() row: RowResult;
  @Input() settings: ReportSettings;
  @Input() headerWeigth = 700;
  @Input() pageSizeDetail: number;
  @Input() stripedBackground = 'rgba(216, 215, 215, 1)';
  @Input() title: string;
  @Input() columnsMaxLength: Map<string,number>;

  //#endregion

  //#region Outputs

  @Output() onLoadDetailRows : EventEmitter<RowDetail> = new EventEmitter<RowDetail>();

  //#endregion

  //#region Properties

  childPage = 1;
  childTotal = 0;

  expanded = false;

  background: string;

  displayedColumns: Array<string> = new Array<string>();

  load = true;

  //#endregion

  //#region Ctor

  constructor() { }

  //#endregion

  //#region Interface Implementations

  ngOnInit() {
    if (this.settings.StripedLines) {
      if (this.row.Index % 2 === 0) {
        this.background = this.stripedBackground;
      }
    }

    if (this.settings.ExpandDetail) {
      this.onClickRow();
    }
  }

  ngDoCheck() {
    if (this.row.Rows && this.row.Rows.length > 0) {
      this.childTotal = this.row.Rows[0].Total;
    }
  }

  //#endregion

  //#region Events

  onClickRow() {
    if (this.row.IsGroup) {
      this.expanded = !this.expanded;

      this.expandRows();
    }
  }

  expandRows() {

    if (this.expanded) {
      this.childPage = !this.expanded ? 1 : this.childPage;

       this.emitLoadDetailRows();
    }
  }

  emitLoadDetailRows() {

    if (this.getCurrentChildRows().length === 0) {
      this.onLoadDetailRows.emit({
        Page: this.childPage,
        Row: this.row
      });
    }

  }

  getMaxLength(column): string {
    return getMaxLength(column, this.columnsMaxLength, this.row.Data[column.Alias].length);
  }

  //#endregion

  //#region DOM manipulation

  getChieldStripedBackground(): string {
    let background = '';

    if (this.stripedBackground) {
      const splited = this.stripedBackground.split(',');

      if (splited && splited.length === 4) {
        splited[3] = Number.parseFloat(splited[3]) >= 0.15 ? (Number.parseFloat(splited[3]) - 0.15).toString() : splited[3];

        if (!splited[3].includes(')')) {
          splited[3] += ')';
        }
      }

      background = splited.join(',');
    }

    return background;
  }

  //#endregion

  //#region Pagination

  getAmountPageFromChild(): number {
    let result = 0;

    if (this.row.Rows.length > 0) {
      result = this.row.Rows[0].AmountPage;
    }

    return result;
  }

  getCurrentChildRows(): Array<RowResult> {
    return this.row.Rows.filter(value => value.Page === this.childPage);
  }

  //#endregion
}
